import { Route, Routes } from "react-router";
import { Home } from "../Home/Home";
import { NotFound } from "../NotFound/NotFound";
import { Users } from "../Users/Users";

export const AllRoutes = () => {
    return (<>
        <Routes>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/users" element={<Users />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    </>);
}